import React, { useState } from 'react';
import './DeliveriesPage.css';

const DeliveriesPage = () => {
  // Order data mapped from Contentful model
  const [orders, setOrders] = useState([
    {
      orderNumber: 'ref_1766339197560',
      clientName: 'Ignatius Musonda',
      phone: '260971873484',
      street: 'Chipata',
      city: 'Chipata',
      province: 'Select State',
      postalCode: '10101',
      additionalInfo: 'apartmenet',
      deliverySteps: [
        { label: 'Order Placed', timestamp: '2025-12-21 17:47', completed: true },
        { label: 'Dispatched', timestamp: '', completed: false },
        { label: 'In Transit', timestamp: '', completed: false },
        { label: 'Out for Delivery', timestamp: '', completed: false },
        { label: 'Delivered', timestamp: '', completed: false },
      ],
    },
  ]);

  const updateDeliveryStatus = (orderIndex, newStatus) => {
    const newOrders = [...orders];
    const stepIndex = newOrders[orderIndex].deliverySteps.findIndex(
      (step) => step.label === newStatus
    );

    if (stepIndex !== -1) {
      newOrders[orderIndex].deliverySteps[stepIndex].completed = true;
      newOrders[orderIndex].deliverySteps[stepIndex].timestamp =
        new Date().toLocaleString();
    }

    setOrders(newOrders);
  };

  const getStatusColor = (step) => {
    if (!step) return '#4CAF50';
    if (step.completed) return '#4CAF50';

    switch (step.label) {
      case 'Order Placed':
        return '#2196F3';
      case 'Dispatched':
        return '#FF9800';
      case 'In Transit':
        return '#FFEB3B';
      case 'Out for Delivery':
        return '#F44336';
      case 'Delivered':
        return '#4CAF50';
      default:
        return '#FFFFFF';
    }
  };

  return (
    <div className="deliveries-page">
      <h2>Deliveries</h2>

      <table className="deliveries-table">
        <thead>
          <tr>
            <th>Order Number</th>
            <th>Client Name</th>
            <th>Phone</th>
            <th>Delivery Address</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {orders.map((order, orderIndex) => {
            const currentStepIndex = order.deliverySteps.findIndex(
              (step) => !step.completed
            );
            const currentStep =
              currentStepIndex !== -1
                ? order.deliverySteps[currentStepIndex]
                : null;

            return (
              <tr key={order.orderNumber}>
                <td>{order.orderNumber}</td>
                <td>{order.clientName}</td>
                <td>{order.phone}</td>

                {/* ✅ CORRECT ADDRESS */}
                <td>
                  {order.street}
                  <br />
                  {order.city}, {order.province}
                  <br />
                  {order.postalCode}
                  <br />
                  {order.additionalInfo}
                </td>

                <td
                  style={{
                    backgroundColor: getStatusColor(currentStep),
                    color: '#fff',
                  }}
                >
                  {currentStep ? currentStep.label : 'Delivered'}
                </td>

                <td>
                  {currentStep && (
                    <select
                      onChange={(e) =>
                        updateDeliveryStatus(orderIndex, e.target.value)
                      }
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select Status
                      </option>
                      {order.deliverySteps.map((step) => (
                        <option
                          key={step.label}
                          value={step.label}
                          disabled={step.completed}
                        >
                          {step.completed
                            ? `${step.label} (Completed)`
                            : step.label}
                        </option>
                      ))}
                    </select>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};


export default DeliveriesPage;

// // src/components/DeliveriesPage.js
// import React, { useState } from 'react';
// import './DeliveriesPage.css';

// const DeliveriesPage = () => {
//   // Dummy order data
//   const [orders, setOrders] = useState([
//     {
//       orderNumber: "123456789",
//       clientName: "John Doe",
//       deliverySteps: [
//         { label: "Order Placed", timestamp: "2024-10-20 10:00 AM", completed: true },
//         { label: "Dispatched", timestamp: "2024-10-21 02:00 PM", completed: true },
//         { label: "In Transit", timestamp: "2024-10-22 08:00 AM", completed: true },
//         { label: "Out for Delivery", timestamp: "", completed: false },
//         { label: "Delivered", timestamp: "", completed: false },
//       ],
//     },
//     {
//       orderNumber: "987654321",
//       clientName: "Jane Smith",
//       deliverySteps: [
//         { label: "Order Placed", timestamp: "2024-10-22 11:00 AM", completed: true },
//         { label: "Dispatched", timestamp: "", completed: false },
//         { label: "In Transit", timestamp: "", completed: false },
//         { label: "Out for Delivery", timestamp: "", completed: false },
//         { label: "Delivered", timestamp: "", completed: false },
//       ],
//     },
//   ]);

//   const updateDeliveryStatus = (orderIndex, newStatus) => {
//     const newOrders = [...orders];
//     const currentStepIndex = newOrders[orderIndex].deliverySteps.findIndex(step => step.label === newStatus);
    
//     if (currentStepIndex !== -1) {
//       newOrders[orderIndex].deliverySteps[currentStepIndex].completed = true;
//       newOrders[orderIndex].deliverySteps[currentStepIndex].timestamp = new Date().toLocaleString();
//     }
    
//     setOrders(newOrders);
//   };

//   const getStatusColor = (step) => {
//     if (step.completed) return '#4CAF50'; // Green
//     switch (step.label) {
//       case "Order Placed":
//         return '#2196F3'; // Blue
//       case "Dispatched":
//         return '#FF9800'; // Orange
//       case "In Transit":
//         return '#FFEB3B'; // Yellow
//       case "Out for Delivery":
//         return '#F44336'; // Red
//       case "Delivered":
//         return '#4CAF50'; // Green
//       default:
//         return '#FFFFFF'; // Default White
//     }
//   };

//   return (
//     <div className="deliveries-page">
//       <h2>Deliveries</h2>
//       <table className="deliveries-table">
//         <thead>
//           <tr>
//             <th>Order Number</th>
//             <th>Client Name</th>
//             <th>Status</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {orders.map((order, orderIndex) => {
//             const currentStepIndex = order.deliverySteps.findIndex(step => !step.completed);
//             const currentStep = order.deliverySteps[currentStepIndex];

//             return (
//               <tr key={order.orderNumber}>
//                 <td>{order.orderNumber}</td>
//                 <td>{order.clientName}</td>
//                 <td style={{ backgroundColor: getStatusColor(currentStep), color: '#fff' }}>
//                   {currentStep ? currentStep.label : 'Delivered'}
//                 </td>
//                 <td>
//                   {currentStep && (
//                     <select
//                       onChange={(e) => updateDeliveryStatus(orderIndex, e.target.value)}
//                       defaultValue=""
//                     >
//                       <option value="" disabled>Select Status</option>
//                       {order.deliverySteps.map((step) => (
//                         <option
//                           key={step.label}
//                           value={step.label}
//                           disabled={step.completed}
//                         >
//                           {step.completed ? `${step.label} (Completed)` : step.label}
//                         </option>
//                       ))}
//                     </select>
//                   )}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default DeliveriesPage;

// // src/components/DeliveriesPage.js
// import React, { useState } from 'react';
// import './DeliveriesPage.css';

// const DeliveriesPage = () => {
//   // Dummy order data
//   const [orders, setOrders] = useState([
//     {
//       orderNumber: "123456789",
//       clientName: "John Doe",
//       deliverySteps: [
//         { label: "Order Placed", timestamp: "2024-10-20 10:00 AM", completed: true },
//         { label: "Dispatched", timestamp: "2024-10-21 02:00 PM", completed: true },
//         { label: "In Transit", timestamp: "2024-10-22 08:00 AM", completed: true },
//         { label: "Out for Delivery", timestamp: "", completed: false },
//         { label: "Delivered", timestamp: "", completed: false },
//       ],
//     },
//     {
//       orderNumber: "987654321",
//       clientName: "Jane Smith",
//       deliverySteps: [
//         { label: "Order Placed", timestamp: "2024-10-22 11:00 AM", completed: true },
//         { label: "Dispatched", timestamp: "", completed: false },
//         { label: "In Transit", timestamp: "", completed: false },
//         { label: "Out for Delivery", timestamp: "", completed: false },
//         { label: "Delivered", timestamp: "", completed: false },
//       ],
//     },
//   ]);

//   const updateDeliveryStatus = (orderIndex, newStatus) => {
//     const newOrders = [...orders];
//     const currentStepIndex = newOrders[orderIndex].deliverySteps.findIndex(step => step.label === newStatus);
    
//     if (currentStepIndex !== -1) {
//       newOrders[orderIndex].deliverySteps[currentStepIndex].completed = true;
//       newOrders[orderIndex].deliverySteps[currentStepIndex].timestamp = new Date().toLocaleString();
//     }
    
//     setOrders(newOrders);
//   };

//   const getStatusColor = (step) => {
//     if (step.completed) return 'lightgreen';
//     switch (step.label) {
//       case "Order Placed":
//         return 'lightblue';
//       case "Dispatched":
//         return 'orange';
//       case "In Transit":
//         return 'yellow';
//       case "Out for Delivery":
//         return 'lightcoral';
//       case "Delivered":
//         return 'green';
//       default:
//         return 'white';
//     }
//   };

//   return (
//     <div className="deliveries-page">
//       <h2>Deliveries</h2>
//       <table className="deliveries-table">
//         <thead>
//           <tr>
//             <th>Order Number</th>
//             <th>Client Name</th>
//             <th>Status</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {orders.map((order, orderIndex) => {
//             const currentStepIndex = order.deliverySteps.findIndex(step => !step.completed);
//             const currentStep = order.deliverySteps[currentStepIndex];

//             return (
//               <tr key={order.orderNumber}>
//                 <td>{order.orderNumber}</td>
//                 <td>{order.clientName}</td>
//                 <td>
//                   {currentStep ? currentStep.label : 'Delivered'}
//                 </td>
//                 <td>
//                   {currentStep && (
//                     <select
//                       onChange={(e) => updateDeliveryStatus(orderIndex, e.target.value)}
//                       defaultValue=""
//                     >
//                       <option value="" disabled>Select Status</option>
//                       {order.deliverySteps.map((step) => (
//                         <option
//                           key={step.label}
//                           value={step.label}
//                           disabled={step.completed}
//                           style={{ backgroundColor: getStatusColor(step) }}
//                         >
//                           {step.completed ? `${step.label} (Completed)` : step.label}
//                         </option>
//                       ))}
//                     </select>
//                   )}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default DeliveriesPage;
